module.exports = __webpack_public_path__ + "img/index-banner2.640dfde8.jpg";